import React from 'react';
import styles from './MonthYearPicker.module.scss';

interface MonthYearPickerProps {
  label?: string;
  name: string;
  value: string; // Format: "YYYY-MM"
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

const MonthYearPicker: React.FC<MonthYearPickerProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  className = '',
}) => {
  // Parse the value to get month and year
  const [year, month] = value ? value.split('-') : ['', ''];

  // Generate year options (current year ± 10 years)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);

  // Month options
  const months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMonth = e.target.value;
    if (newMonth && year) {
      onChange(`${year}-${newMonth}`);
    }
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = e.target.value;
    if (newYear && month) {
      onChange(`${newYear}-${month}`);
    }
  };

  const containerClasses = [
    styles.container,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
     <div className={styles.monthYearWrapper}>
  <div className={styles.selectGroup}>
    {/* <label className={styles.label}>Month</label> */}
    <select
      name={`${name}-month`}
      value={month || ''}
      onChange={handleMonthChange}
      disabled={disabled}
      required={required}
      className={`${styles.select} ${error ? styles.error : ''}`}
    >
      <option value="">Select Month</option>
      {months.map((m) => (
        <option key={m.value} value={m.value}>
          {m.label}
        </option>
      ))}
    </select>
  </div>

  <div className={styles.selectGroup}>
    {/* <label className={styles.label}>Year</label> */}
    <select
      name={`${name}-year`}
      value={year || ''}
      onChange={handleYearChange}
      disabled={disabled}
      required={required}
      className={`${styles.select} ${error ? styles.error : ''}`}
    >
      <option value="">Select Year</option>
      {years.map((y) => (
        <option key={y} value={y}>
          {y}
        </option>
      ))}
    </select>
  </div>
</div>

      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default MonthYearPicker;